<template>
  <div>
    <div @click='wxPay'>支付</div>
    <ul>
      <li>
        123
        <img src="@images/detail.jpg">
      </li>
      <li>
        456
        <img src="@images/swiper.png">
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'List',
  data () {
    return {
    }
  },
  methods: {
    getBaseInfo () {
      let vm = this
      axios.post('/wechat.php/Feedback/getFeedbacklist', {
        user_id: localStorage.user_id,
        page: 1
      }).then(function (res) {
        res = res.data
        if (res.code === 1) {
          const data = res.data
          vm.dataList = data.data_list
        }
      })
      vm.$wx.setConfig()
      let obj = {
        title: 'ninhao',
        desc: 'nihaonihao',
        imgUrl: 'https://juchenghb1oss.jucheng01.net/ym/uid2/applet/20181228/6ec67c87df3a51fb46037df5a5a799ff.jpg',
        link: location.href
      }
      console.log(obj)
      vm.$wx.jssdk.ready(function () {
        vm.$wx.share(obj).then(res => {
          console.log(res)
        })
      })
    },
    wxPay () {
      let vm = this
      alert(33333)
      axios.post('/wechat.php/Example/wxpay').then(function (res) {
        res = res.data
        if (res.code === 1) {
          const data = res.data
          vm.$wx.wxPay(data).then(res => {
            console.log(res)
          })
        }
      })
    }
  },
  mounted () {
    this.getBaseInfo()
  }
}
</script>

<style lang="stylus">
  body
    padding-bottom 1.2rem !important
    ul
      background #fff
      li
        padding .2rem
        height 10rem
</style>



// WEBPACK FOOTER //
// src/pages/demo/List.vue